export default {
	computed: {
		store() {
			return this.$store.state[this.storeName];
		},
	},
	methods: {
		dispatch() {
			let args = [...arguments];
			let method = args.shift();
			return this.$store.dispatch(this.storeName + "/" + method, ...args);
		},
	},
	props: {
		storeName: {
			required: true,
			type: String,
		},
	},
};
